import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ComponentFactoryResolver } from "@angular/core";
import { DynamicPanel, LandingPanel, GroupPanel } from '../../interfaces';
import { ServiceAgent } from 'src/app/framework-modules/formdata/form/serviceAgent';
import { CtTableComponent } from '../../../../framework-modules/elements/ct-table/component'
import { FilterRequest } from 'src/app/framework-modules/formdata/form/types';
import { SessionComponent } from '../../component';
import { StaffDetailForm, StaffDetailFd } from 'src/app/framework-modules/formdata/gen/staffDetailForm';

@Component({
  selector: "staff-list",
  templateUrl: "./component.html",
  styleUrls: ["./component.scss"]
})


export class StaffListComponent implements DynamicPanel, OnInit {
  @ViewChild("gridTable", { static: false }) gtable: CtTableComponent;
  @Input() inputData: any;
  @Input() parentPanel: GroupPanel;
  @Input() session: SessionComponent;
  public tableData: any;
  public from: StaffDetailForm;
  public fd: StaffDetailFd;

  constructor(private sa: ServiceAgent) {
    this.from = StaffDetailForm.getInstance();
    this.fd = this.from.newFormData(this.sa);
  }

  metaDataInit() {
    this.tableData = {
      data: [] = [],
      metaData: {
        column_names: [
          "firstName",
          "empId",
          "phoneNumber",
          "email",
          "departmentName"
        ],
        display_names: {
          "firstName": "Staff Name",
          "empId": "Employee ID",
          "phoneNumber": "Phone Number",
          "email": "Email",
          "departmentName": "Department Name"
        },
        edit: true,
        search: true,
        view: true,
        placeholder: "Search By Staff Name, Employee ID, email, Department"
      }
    };
    this.filter();
  }

  ngOnInit() {
    this.metaDataInit();
  }

  filter() {
    /**
     * initial filter conditions
     */
    const filter: FilterRequest = {
      conditions: {},
      sort: { name: "asc" },
      maxRows: 10
    };
    const obs = this.fd.filter(filter);

    obs.subscribe(
      data => {
        this.tableData.data = data;
        this.gtable.update();
      },
      msgs => {
        console.error(msgs);
      }
    );
  }

  addStaff() {
    this.parentPanel.navigate('StaffAdd')
  }

  edit($event) {
    this.parentPanel.navigate('StaffEdit', this.tableData.data[$event].staffId)
  }

  view($event) {
    this.parentPanel.navigate('StaffView', this.tableData.data[$event].staffId)
  }
}
